import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { wrapFraction } from "@aprao/common/src/math/wrapFraction.js";
import type { Fraction, WithValue } from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

export class FractionHolderDelegate {
  constructor(readonly $model: WithValue<Fraction>) {
    makeAutoObservable(this);
  }

  get value() {
    return wrapFraction(this.$model.value);
  }

  set value(value: BigFraction | null) {
    this.$model.value = value?.toFraction() ?? null;
  }
}
